<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [title]="pageTitle"
      [class]="extraClass"
      [canGoBack]="false" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper class="right-side-scroll-enabled">

    @if (loaded) {
      <tidy-alert>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="task?.title" />
        </tidy-row>
        <tidy-row class="no-padding">
          <tidy-image
            [src]="getIssueHeaderIcon(task)"
            class="urgency-icon" />
          <tidy-text
            [body]="issueAddress?.address_name || issueAddress?.address1 + (issueAddress?.address2 ? ', ' + (issueAddress.address2 | translate) : '')" />
        </tidy-row>
      </tidy-alert>
      @if (loadingActionSuggestions) {
        <tidy-row>
          <tidy-text
            [body]="'<i>Generating Concierge Action Plan</i>'" />
        </tidy-row>
        <div class="generating-action-plan generating">
          <div class="step">
            <tidy-image
              class="step__icon"
              src="assets/img/bow-chip.svg"
              style="width: 40px; height: 50px" />
            <tidy-text
              body="<i>Analyzing Task...</i>" />
          </div>
          <div class="step">
            <tidy-image
              class="step__icon"
              src="assets/img/bow-chip.svg"
              style="width: 40px; height: 50px" />
            <tidy-text
              body="<i>Analyzing Similar Action Plans...</i>" />
          </div>
          <div class="step">
            <tidy-image
              class="step__icon icon-pulse"
              src="assets/img/bow-chip.svg"
              style="width: 40px; height: 50px" />
            <tidy-text
              body="<i>Generating Action Plan...</i>" />
          </div>
        </div>
      }
      @if (!loadingActionSuggestions) {
        <tidy-row>
          <tidy-text
            [header]="'Concierge Action Plan:'" />
        </tidy-row>
      }
      @for (suggestion of conciergeActionSuggestions?.suggestions; track suggestion; let i = $index) {
        <tidy-card>
          @if (editingSuggestion !== suggestion) {
            <div class="action-flex-row">
              <div class="first-column">
                <tidy-row class="vertical-align-middle extra-bottom-padding">
                  <tidy-image
                    class="step__icon"
                    src="assets/img/concierge.svg"
                    style="width: 25px; height: 20px" />
                  <tidy-text
                    [header]="suggestion.title" />
                </tidy-row>
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [body]="suggestion.description" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [helper]="suggestion.scheduled === 'Immediate' || suggestion.scheduled === 'immediate' ? '<i>Scheduled to do immediately</i>' : ('<i>Scheduled to do on ' | translate) + (suggestion.scheduled | parseDateTime: 'MMM d') + '</i>'" />
                </tidy-row>
              </div>
              <div class="second-column">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    class="step__icon edit-delete-icon header-size"
                    src="assets/svg/create.svg"
                    (action)="editSuggestion(suggestion)" />
                  <tidy-image
                    class="step__icon edit-delete-icon header-size"
                    src="assets/svg/trash.svg"
                    (action)="deleteSuggestion(i)" />
                </tidy-row>
              </div>
            </div>
          }
          @if (editingSuggestion == suggestion) {
            <form [formGroup]="editSuggestionForm">
              <tidy-row>
                <tidy-textarea
                  label="Title"
                  [icon]="'assets/svg/create.svg'"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a description'"
                  [form]="editSuggestionForm.get('title')"
                  formControlName="title" />
              </tidy-row>
              <tidy-row>
                <tidy-textarea
                  label="Description"
                  [icon]="'assets/svg/document-text.svg'"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a description'"
                  [form]="editSuggestionForm.get('description')"
                  formControlName="description" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-radio-button
                  [label]="'When should concierge do this?'"
                  formControlName="scheduled"
                  [form]="editSuggestionForm.get('scheduled')"
                  (optionChange)="selectWhenConciergeShouldDo($event, suggestion)"
                  [items]="[{value: 'Immediate', viewValue: 'Immediately'}, {value: 'Scheduled', viewValue: 'Scheduled for a date'}]" />
              </tidy-row>
              @if (suggestion?.scheduled !== 'Immediate') {
                <tidy-row class="extra-bottom-padding">
                  <tidy-datepicker
                    label="Select date"
                    [icon]="'assets/svg/calendar.svg'"
                    formControlName="date"
                    [form]="editSuggestionForm.get('date')"
                    errorMessage="Please select a date."
                    [submitted]="submitted" />
                </tidy-row>
              }
              <tidy-row>
                <tidy-button
                  text="Save"
                  [action]="boundConfirmEditSuggestion"
                  class="secondary" />
              </tidy-row>
              <tidy-row>
                <tidy-button
                  text="Cancel"
                  [action]="boundCancelEditSuggestion"
                  class="secondary" />
              </tidy-row>
            </form>
          }
        </tidy-card>
      }
      @if (isAddingAction) {
        <tidy-card>
          <form [formGroup]="editSuggestionForm">
            <tidy-row>
              <tidy-textarea
                label="Title"
                [icon]="'assets/svg/create.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description'"
                [form]="editSuggestionForm.get('title')"
                formControlName="title" />
            </tidy-row>
            <tidy-row>
              <tidy-textarea
                label="Description"
                [icon]="'assets/svg/document-text.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description'"
                [form]="editSuggestionForm.get('description')"
                formControlName="description" />
            </tidy-row>
            <tidy-row>
              <tidy-button
                text="Save"
                [action]="boundConfirmEditSuggestion"
                class="secondary" />
            </tidy-row>
            <tidy-row>
              <tidy-button
                text="Cancel"
                [action]="boundCancelEditSuggestion"
                class="secondary" />
            </tidy-row>
          </form>
        </tidy-card>
      }
      @if (!loadingActionSuggestions) {
        @if (!isAddingAction) {
          <tidy-row [align]="'center'">
            <tidy-text
              [actionBody]="'Add Action'"
              (action)="addActionPlanStep()"
              class="link" />
          </tidy-row>
        }
        <tidy-button
          text="Create Concierge Action Plan"
          [action]="boundCreateConciergeActionPlan"
          class="primary"
          [disabled]="editSuggestionForm" />
        <tidy-row [align]="'center'">
          <tidy-text
            actionBody="Skip For Now"
            (action)="skipActionPlan()"
            class="link" />
        </tidy-row>
      }
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content>
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

